import type { LazyQueryHookOptions, QueryHookOptions, QueryResult } from '@apollo/client';
import type { ConstValues } from '@openx/types/helpers.ts';
import type { OaSession } from '@openx/types/oa-types/session.ts';
import type { Auth } from 'firebase/auth';
import type { Location, NavigateFunction } from 'react-router';
import type { FirebaseListenerResult } from '../../firebaseIntegration/types.ts';
import type { fetchAuthToken } from '../../firebaseIntegration/utils.ts';
import type {
  CheckUserPermissionsQuery,
  CheckUserPermissionsQueryVariables,
} from '../../graphql/query/CheckUserPermissions.generated.tsx';
import type { SessionQuery, SessionQueryVariables } from '../../graphql/query/GetSession.generated.tsx';

export type Session = OaSession;

export type CheckUserPermissionsQueryResult = QueryResult<
  CheckUserPermissionsQuery,
  CheckUserPermissionsQueryVariables
>;

export type SessionQueryResult = QueryResult<SessionQuery, SessionQueryVariables>;

export const AuthState = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  AUTHENTICATED: 'AUTHENTICATED',
  CHECKING_PERMISSIONS: 'CHECKING_PERMISSIONS',
  PERMISSIONS_CHECKED: 'PERMISSIONS_CHECKED',
  OBTAINING_SESSION: 'OBTAINING_SESSION',
  SESSION_OBTAINED: 'SESSION_OBTAINED',
  SESSION_STALE: 'SESSION_STALE',
} as const;
export type AuthState = ConstValues<typeof AuthState>;

export interface StateActionArguments {
  checkPermissionQuery: CheckUserPermissionsQueryResult;
  currentPage: string;
  fetchAuthToken: typeof fetchAuthToken;
  firebaseListener: FirebaseListenerResult;
  pageIsPublic: boolean;
  sessionContextValue: Session | null;
  sessionQuery: SessionQueryResult;
  setAuthState: (authState: AuthState) => void;
  skipAuth: boolean;
  triggerCheckPermissionsQuery: (
    options: QueryHookOptions<CheckUserPermissionsQuery, CheckUserPermissionsQueryVariables>
  ) => Promise<unknown>;
  triggerSessionQuery: (options?: LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) => Promise<unknown>;
  auth: Auth;
  location: Location;
  navigate: NavigateFunction;
  logout: () => Promise<void>;
}
